import React from "react"

import Section from "@components/section"
import ClickableImage from "@components/clickableImage"
import BottomButtons from "@components/bottomButtons"
import Button from "@components/button"
import matchImg from "@images/season2/ssb-duizhen.png"

const Bottom = ({ isEn = false }) => {
  return (
    <>
      <Section title={isEn ? "Schedule" : "对阵表"}>
        <ClickableImage className="fluidImage" src={matchImg} />
      </Section>
      <BottomButtons isEn={isEn}>
        {() => {
          return (
            <div className="enrollModal enrollModal-thinBtmPadding">
              <p>
                {isEn
                  ? "Please select the appropriate match group according to your personal time ( can only register once)"
                  : "请根据个人时间选择可参加的比赛组（不可重复报名）"}
              </p>
              <div className="enrollList">
                {[
                  {
                    name: "GROUP A",
                    date: "6.26",
                    time: "14 : 00",
                    link: "http://sparkidea.mikecrm.com/sGsS62V",
                  },
                  {
                    name: "GROUP B",
                    date: "6.27",
                    time: "14 : 00",
                    link: "http://sparkidea.mikecrm.com/TBalkZx",
                  },
                  {
                    name: "GROUP C",
                    date: "7.4",
                    time: "14 : 00",
                    link: "http://sparkidea.mikecrm.com/iZNBrCS",
                  },
                  {
                    name: "GROUP D",
                    date: "7.5",
                    time: "14 : 00",
                    link: "http://sparkidea.mikecrm.com/DU87g4q",
                  },
                ].map(({ name, date, time, link }) => {
                  return (
                    <div className="enroll" key={name}>
                      <h3>{name}</h3>
                      <h2>
                        {date}
                        <br />
                        {time}
                      </h2>

                      <Button color="blue" href={link}>
                        {isEn ? "Register" : "确认报名"}
                      </Button>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        }}
      </BottomButtons>
    </>
  )
}

export default Bottom
